module.exports = __webpack_public_path__ + "static/img/11.7566ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/7/11.png
// module id = BSFt
// module chunks = 0